var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"az-list"},_vm._l((_vm.az),function(letter){return _c('li',{key:letter,class:{ 'active': letter === _vm.getLetter },on:{"click":function($event){return _vm.$router.push(`/topics/${letter}`)}}},[_vm._v(" "+_vm._s(_vm._f("upper")(letter))+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }